<script setup lang="ts">
/**
 * v-model textarea carrying the canonical builder textarea classes.
 * `mono` adds `font-mono` (list editors).
 */
withDefaults(defineProps<{
  modelValue?: string | null
  rows?: number | string
  placeholder?: string
  mono?: boolean
}>(), {
  rows: 4,
})

defineEmits<{ 'update:modelValue': [value: string] }>()
</script>

<template>
  <textarea
    :value="modelValue ?? ''"
    :rows="rows"
    :placeholder="placeholder"
    :class="mono ? 'font-mono' : ''"
    class="w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring resize-none"
    @input="$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
  />
</template>
